import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAndroidNotificationChannels = "/engagement/android_notification_channels";
export const engagementAndroidNotificationChannelsCacheKeys: AllRouteEndpoints[] = [
  engagementAndroidNotificationChannels,
];
